var map = {
	"./black/2_user.svg": "987e",
	"./black/3_user.svg": "f541",
	"./black/activity.svg": "7326",
	"./black/add_user.svg": "8975",
	"./black/arow_up.svg": "006e",
	"./black/arrow_down.svg": "e61f",
	"./black/arrow_down_2.svg": "b51e",
	"./black/arrow_down_3.svg": "758e",
	"./black/arrow_down_circle.svg": "ebb7",
	"./black/arrow_down_square.svg": "1fc9",
	"./black/arrow_left.svg": "deb8",
	"./black/arrow_left_2.svg": "aace",
	"./black/arrow_left_3.svg": "1eea",
	"./black/arrow_left_circle.svg": "0514",
	"./black/arrow_left_square.svg": "926b",
	"./black/arrow_right.svg": "3b87",
	"./black/arrow_right_2.svg": "a89a",
	"./black/arrow_right_3.svg": "2ba3",
	"./black/arrow_right_circle.svg": "3556",
	"./black/arrow_right_square.svg": "7126",
	"./black/arrow_up_2.svg": "554a",
	"./black/arrow_up_3.svg": "1828",
	"./black/arrow_up_circle.svg": "63cd",
	"./black/arrow_up_square.svg": "f5fd",
	"./black/bag.svg": "85e8",
	"./black/bag_2.svg": "3b50",
	"./black/bookmark.svg": "0cf4",
	"./black/burger.svg": "d2b9",
	"./black/buy.svg": "97d7",
	"./black/calendar.svg": "4a18",
	"./black/call.svg": "108e",
	"./black/call_missed.svg": "f621",
	"./black/call_silent.svg": "16a7",
	"./black/calling.svg": "bb82",
	"./black/camera.svg": "76dc",
	"./black/category.svg": "f8bd",
	"./black/chart.svg": "fd03",
	"./black/chat.svg": "bc6f",
	"./black/close_square.svg": "f160",
	"./black/danger.svg": "2b33",
	"./black/delete.svg": "9224",
	"./black/discount.svg": "1e58",
	"./black/discovery.svg": "5587",
	"./black/document.svg": "07fa",
	"./black/download.svg": "6af9",
	"./black/edit.svg": "39de",
	"./black/edit_square.svg": "0776",
	"./black/filter.svg": "f5e3",
	"./black/filter_2.svg": "bcf3",
	"./black/folder.svg": "b5c7",
	"./black/game.svg": "e79c",
	"./black/graph.svg": "24ac",
	"./black/heart.svg": "6469",
	"./black/hide.svg": "bc21",
	"./black/home.svg": "78ff",
	"./black/horizontal-flip.svg": "7955",
	"./black/image.svg": "d619",
	"./black/image_2.svg": "2a3e",
	"./black/info_circle.svg": "d6db",
	"./black/info_square.svg": "d399",
	"./black/location.svg": "b373",
	"./black/lock.svg": "d36f",
	"./black/login.svg": "2480",
	"./black/logout.svg": "2f3d",
	"./black/message.svg": "bca5",
	"./black/more_circle.svg": "fe19",
	"./black/more_square.svg": "0010",
	"./black/notification.svg": "7965",
	"./black/paper.svg": "5b9b",
	"./black/paper_download.svg": "acbc",
	"./black/paper_fail.svg": "669e",
	"./black/paper_negative.svg": "3f62",
	"./black/paper_plus.svg": "44c6",
	"./black/paper_upload.svg": "f747",
	"./black/password.svg": "c6b5",
	"./black/play.svg": "ce99",
	"./black/plus.svg": "ae3e",
	"./black/profile.svg": "554f",
	"./black/refresh.svg": "0e0c",
	"./black/scan.svg": "6d1f",
	"./black/search.svg": "7e29",
	"./black/send.svg": "8bec",
	"./black/setting.svg": "7cf5",
	"./black/shield_done.svg": "2cf46",
	"./black/shield_fail.svg": "6a43",
	"./black/show.svg": "e834",
	"./black/star.svg": "0118",
	"./black/swap.svg": "b478",
	"./black/tick_square.svg": "fe3e",
	"./black/ticket.svg": "97ea",
	"./black/ticket_star.svg": "290a",
	"./black/time_circle.svg": "0ef8",
	"./black/time_square.svg": "faf7",
	"./black/unlock.svg": "f766",
	"./black/upload.svg": "2a98",
	"./black/vertical-flip.svg": "9c25",
	"./black/video.svg": "22dd",
	"./black/voice.svg": "5bf6",
	"./black/voice_2.svg": "63b1",
	"./black/volume_down.svg": "b7c0",
	"./black/volume_off.svg": "6dc3",
	"./black/volume_up.svg": "93f4",
	"./black/wallet.svg": "ff06",
	"./black/work.svg": "a3c9",
	"./error/2_user.svg": "d209",
	"./error/3_user.svg": "0c51",
	"./error/activity.svg": "b05b",
	"./error/add_user.svg": "576b",
	"./error/arow_up.svg": "9d83",
	"./error/arrow_down.svg": "976d",
	"./error/arrow_down_2.svg": "6692",
	"./error/arrow_down_3.svg": "3fbc",
	"./error/arrow_down_circle.svg": "2cbb",
	"./error/arrow_down_square.svg": "25b1",
	"./error/arrow_left.svg": "05b7",
	"./error/arrow_left_2.svg": "035d",
	"./error/arrow_left_3.svg": "42ff",
	"./error/arrow_left_circle.svg": "818e",
	"./error/arrow_left_square.svg": "856d",
	"./error/arrow_right.svg": "5511",
	"./error/arrow_right_2.svg": "14f0",
	"./error/arrow_right_3.svg": "ecb8",
	"./error/arrow_right_circle.svg": "9931",
	"./error/arrow_right_square.svg": "744a",
	"./error/arrow_up_2.svg": "a260",
	"./error/arrow_up_3.svg": "8baf",
	"./error/arrow_up_circle.svg": "a4f4",
	"./error/arrow_up_square.svg": "110f",
	"./error/bag.svg": "b13a",
	"./error/bag_2.svg": "7367",
	"./error/bookmark.svg": "7cf8",
	"./error/burger.svg": "0a58",
	"./error/buy.svg": "3153",
	"./error/calendar.svg": "fc7c",
	"./error/call.svg": "aa76",
	"./error/call_missed.svg": "5805",
	"./error/call_silent.svg": "7a5e",
	"./error/calling.svg": "2904",
	"./error/camera.svg": "cb9f",
	"./error/category.svg": "698eb",
	"./error/chart.svg": "5149",
	"./error/chat.svg": "77fa",
	"./error/close_square.svg": "c922",
	"./error/danger.svg": "8de3",
	"./error/delete.svg": "8cc6",
	"./error/discount.svg": "298a",
	"./error/discovery.svg": "d216",
	"./error/document.svg": "5e59",
	"./error/download.svg": "2463",
	"./error/edit.svg": "d5fa",
	"./error/edit_square.svg": "2ebc",
	"./error/filter.svg": "6ad4",
	"./error/filter_2.svg": "95ab",
	"./error/folder.svg": "ef61",
	"./error/game.svg": "9e7e",
	"./error/graph.svg": "490d",
	"./error/heart.svg": "daca",
	"./error/hide.svg": "29a7",
	"./error/home.svg": "5f62",
	"./error/image.svg": "ed94",
	"./error/image_2.svg": "2b84",
	"./error/info_circle.svg": "9ba3",
	"./error/info_square.svg": "e054",
	"./error/location.svg": "3b58",
	"./error/lock.svg": "00df",
	"./error/log-out.svg": "2773",
	"./error/login.svg": "0f80",
	"./error/logout.svg": "f6b5",
	"./error/message.svg": "862e",
	"./error/more_circle.svg": "7557",
	"./error/more_square.svg": "13f9",
	"./error/notification.svg": "ea55",
	"./error/paper.svg": "b2fb",
	"./error/paper_download.svg": "e05d",
	"./error/paper_fail.svg": "bb5e",
	"./error/paper_negative.svg": "ee9f",
	"./error/paper_plus.svg": "497f",
	"./error/paper_upload.svg": "b587",
	"./error/password.svg": "1c94",
	"./error/play.svg": "ac13",
	"./error/plus.svg": "c660",
	"./error/profile.svg": "373e",
	"./error/scan.svg": "5862",
	"./error/search.svg": "5122",
	"./error/send.svg": "3e05",
	"./error/setting.svg": "48a2",
	"./error/shield_done.svg": "d5d2",
	"./error/shield_fail.svg": "cdb4",
	"./error/show.svg": "3961",
	"./error/star.svg": "5a30",
	"./error/swap.svg": "5415",
	"./error/tick_square.svg": "16fb",
	"./error/ticket.svg": "bd58",
	"./error/ticket_star.svg": "2af7",
	"./error/time_circle.svg": "5e42",
	"./error/time_square.svg": "1c24",
	"./error/unlock.svg": "e90d",
	"./error/upload.svg": "3c07",
	"./error/video.svg": "0c6a",
	"./error/voice.svg": "4daf",
	"./error/voice_2.svg": "6f44",
	"./error/volume_down.svg": "8379",
	"./error/volume_off.svg": "dafa",
	"./error/volume_up.svg": "e8d5",
	"./error/wallet.svg": "e3e1",
	"./error/work.svg": "5277",
	"./login/eyeClose.svg": "885c",
	"./login/eyeOpen.svg": "27e6",
	"./others/arrow-left.svg": "ac6d",
	"./others/more.svg": "d380",
	"./others/sortBy-arrow-blue.svg": "de6c",
	"./primary/2_user.svg": "bfc4",
	"./primary/3_user.svg": "fc9c",
	"./primary/activity.svg": "428a",
	"./primary/add_user.svg": "b315",
	"./primary/arow_up.svg": "38ce",
	"./primary/arrow_down.svg": "e0d6",
	"./primary/arrow_down_2.svg": "45dd",
	"./primary/arrow_down_3.svg": "05f9",
	"./primary/arrow_down_circle.svg": "4655",
	"./primary/arrow_down_square.svg": "bfe7",
	"./primary/arrow_left.svg": "ef63",
	"./primary/arrow_left_2.svg": "eac6",
	"./primary/arrow_left_3.svg": "2295",
	"./primary/arrow_left_circle.svg": "7b78",
	"./primary/arrow_left_square.svg": "1df2",
	"./primary/arrow_right.svg": "72d1",
	"./primary/arrow_right_2.svg": "7e98",
	"./primary/arrow_right_3.svg": "b0de",
	"./primary/arrow_right_circle.svg": "4061",
	"./primary/arrow_right_square.svg": "7e16",
	"./primary/arrow_up_2.svg": "9722",
	"./primary/arrow_up_3.svg": "c8d1",
	"./primary/arrow_up_circle.svg": "67b6",
	"./primary/arrow_up_square.svg": "e6fd",
	"./primary/bag.svg": "4284",
	"./primary/bag_2.svg": "9999",
	"./primary/bookmark.svg": "e0b0",
	"./primary/burger.svg": "9382",
	"./primary/buy.svg": "eced",
	"./primary/calendar.svg": "35f1",
	"./primary/call.svg": "8a50",
	"./primary/call_missed.svg": "826a",
	"./primary/call_silent.svg": "6be8",
	"./primary/calling.svg": "4963",
	"./primary/camera.svg": "bf3a",
	"./primary/category.svg": "32bc",
	"./primary/chart.svg": "625b",
	"./primary/chat.svg": "00ca",
	"./primary/close_square.svg": "1b69",
	"./primary/danger.svg": "5be6",
	"./primary/delete.svg": "e00e",
	"./primary/discount.svg": "8966",
	"./primary/discovery.svg": "baa7",
	"./primary/document.svg": "54b6",
	"./primary/download.svg": "b060",
	"./primary/edit.svg": "e120",
	"./primary/edit_square.svg": "ed9a",
	"./primary/filter.svg": "16ff",
	"./primary/filter_2.svg": "831a",
	"./primary/folder.svg": "8180",
	"./primary/game.svg": "080b",
	"./primary/graph.svg": "c031",
	"./primary/heart.svg": "600c",
	"./primary/hide.svg": "576f",
	"./primary/home.svg": "25ad",
	"./primary/image.svg": "4bd2",
	"./primary/image_2.svg": "bf88",
	"./primary/info_circle.svg": "0e6e",
	"./primary/info_square.svg": "c3da",
	"./primary/location.svg": "a333",
	"./primary/lock.svg": "0771",
	"./primary/login.svg": "bd23",
	"./primary/logout.svg": "7f30",
	"./primary/message.svg": "4452",
	"./primary/more_circle.svg": "3bf9",
	"./primary/more_square.svg": "4c89",
	"./primary/notification.svg": "e9e4",
	"./primary/paper.svg": "8ede",
	"./primary/paper_download.svg": "2d9e",
	"./primary/paper_fail.svg": "7bda",
	"./primary/paper_negative.svg": "f6b8",
	"./primary/paper_plus.svg": "54be",
	"./primary/paper_upload.svg": "6df1",
	"./primary/password.svg": "ed44",
	"./primary/play.svg": "3141",
	"./primary/plus.svg": "a0cb",
	"./primary/profile.svg": "4962",
	"./primary/scan.svg": "14bf",
	"./primary/search.svg": "4819",
	"./primary/send.svg": "2fe1",
	"./primary/setting.svg": "1f6e",
	"./primary/shield_done.svg": "5f46",
	"./primary/shield_fail.svg": "3ed3",
	"./primary/show.svg": "1519",
	"./primary/star.svg": "1349",
	"./primary/swap.svg": "feaf",
	"./primary/tick_square.svg": "58b4",
	"./primary/tick_square_2.svg": "f5b4",
	"./primary/ticket.svg": "3ac2",
	"./primary/ticket_star.svg": "d2e3",
	"./primary/time_circle.svg": "0443",
	"./primary/time_square.svg": "1726",
	"./primary/unlock.svg": "f5ba",
	"./primary/upload.svg": "87af",
	"./primary/video.svg": "003c",
	"./primary/voice.svg": "c9da",
	"./primary/voice_2.svg": "daf0",
	"./primary/volume_down.svg": "25a0",
	"./primary/volume_off.svg": "f78a",
	"./primary/volume_up.svg": "2dd1",
	"./primary/wallet.svg": "ccc7",
	"./primary/work.svg": "d6b6",
	"./report/close_square.svg": "7245",
	"./report/lock.svg": "3518",
	"./report/send.svg": "719d",
	"./table/checkmark-square.svg": "5db1",
	"./table/minus-square.svg": "9fec",
	"./table/square.svg": "3990",
	"./toast/close-alert.svg": "8181",
	"./toast/close-error.svg": "113d",
	"./toast/close-info.svg": "a87d",
	"./toast/close-success.svg": "5a38",
	"./toast/error.svg": "76e2",
	"./toast/info.svg": "727f",
	"./toast/success.svg": "1cc8",
	"./toast/warning.svg": "8484",
	"./white/arrow-down.svg": "7f01",
	"./white/edit.svg": "05ce",
	"./white/menu.svg": "25f1",
	"./white/navigation.svg": "8554",
	"./white/plus.svg": "46d4",
	"./white/refresh.svg": "9840"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";